import {plSetting} from "./config/pl";

export const plMoment = (moment: any) => {
    return moment.locale('pl', plSetting);
}
